<div class="password-reset-wrapper">

  <div [formGroup]="passwordResetForm" class="password-reset-form">

    <div class="password-reset-form__header">
      <div i18n="@@core.password-reset-form.title">Reset Password</div>
      <mat-icon class="logo" svgIcon="logo"></mat-icon>
    </div>

    <div class="password-reset-form__body">
      <tm-error-message [message]="(errorMessage$ | async) ?? ''"/>
      @if (infoMessage$ | async; as infoMessage) {
        <tm-info-message [message]="infoMessage"/>
      }

      <p class="token-validity">Reset token is valid until {{ token.tokenValidUntil | date:'medium' }}</p>

      @if (tokenIsValid()) {
        <div class="form-field">
          <label for="username" i18n="@@core.password-reset-form.username">Username</label>
          <input
            [tmAutoFocus]="true"
            formControlName="username"
            id="username"
            name="username"
            type="text"
          />
          @if (passwordResetForm.controls.username.errors) {
            <mat-error i18n="@@core.password-reset-form.error.username-invalid">Username is invalid</mat-error>
          }
        </div>

        <div class="form-field">
          <label for="newPassword" i18n="@@core.password-reset-form.newpassword">New Password</label>
          <input
            formControlName="newPassword"
            id="newPassword"
            name="newPassword"
            type="password"
          />
          @if (passwordResetForm.controls.newPassword.errors?.['minlength']) {
            <mat-error i18n="@@core.password-reset-form.error.password-tooshort">Password shorter
              than {{ passwordResetForm.controls.newPassword.errors['minlength'].requiredLength }}
            </mat-error>
          }
          @if (passwordResetForm.controls.newPassword.errors?.['weakPassword']) {
            <mat-error i18n="@@core.password-reset-form.error.password-toosimple">Password too short or too easily guessable</mat-error>
          }
        </div>

        <div class="form-field">
          <label for="confirmedPassword" i18n="@@core.password-reset-form.confirmedpassword">Confirm Password</label>
          <input
            formControlName="confirmedPassword"
            id="confirmedPassword"
            name="confirmedPassword"
            type="password"
          />
          @if (passwordResetForm.controls.confirmedPassword.errors?.['passwordMismatch']) {
            <mat-error i18n="@@core.password-reset-form.error.need-match">Passwords need to match</mat-error>
          }
        </div>

        <div class="buttons">
          <button (click)="savePassword()"
                  [disabled]="passwordResetForm.invalid"
                  color="primary"
                  mat-flat-button
                  name="login">
            <span i18n="@@core.password-reset-form.save">Save new password</span>
          </button>
        </div>
      }
      <div class="login-link">
        <a i18n="@@core.password-reset-form.return" routerLink="/login">Return to Login</a>
      </div>

    </div>

  </div>
</div>
